import createIcon from '@/lib/create-icon'

const SpeedwayIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      fill='none'
      d='M37.3749 36.4168C40.0213 36.4168 42.1666 34.2715 42.1666 31.6252C42.1666 28.9788 40.0213 26.8335 37.3749 26.8335C34.7286 26.8335 32.5833 28.9788 32.5833 31.6252C32.5833 34.2715 34.7286 36.4168 37.3749 36.4168Z'
      stroke='url(#paint0_linear_5314_712)'
      strokeWidth='2.875'
    />
    <path
      fill='none'
      d='M37.3749 36.4168C40.0213 36.4168 42.1666 34.2715 42.1666 31.6252C42.1666 28.9788 40.0213 26.8335 37.3749 26.8335C34.7286 26.8335 32.5833 28.9788 32.5833 31.6252C32.5833 34.2715 34.7286 36.4168 37.3749 36.4168Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
    />
    <path
      fill='none'
      d='M37.3749 36.4168C40.0213 36.4168 42.1666 34.2715 42.1666 31.6252C42.1666 28.9788 40.0213 26.8335 37.3749 26.8335C34.7286 26.8335 32.5833 28.9788 32.5833 31.6252C32.5833 34.2715 34.7286 36.4168 37.3749 36.4168Z'
      stroke='url(#paint1_radial_5314_712)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
    />
    <path
      fill='none'
      d='M27.6306 34.5002C27.1177 33.3262 26.8333 32.0298 26.8333 30.6668C26.8333 25.3741 31.1239 21.0835 36.4166 21.0835C37.073 21.0835 37.714 21.1494 38.3333 21.2752'
      stroke='url(#paint2_linear_5314_712)'
      strokeWidth='2.875'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M27.6306 34.5002C27.1177 33.3262 26.8333 32.0298 26.8333 30.6668C26.8333 25.3741 31.1239 21.0835 36.4166 21.0835C37.073 21.0835 37.714 21.1494 38.3333 21.2752'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M27.6306 34.5002C27.1177 33.3262 26.8333 32.0298 26.8333 30.6668C26.8333 25.3741 31.1239 21.0835 36.4166 21.0835C37.073 21.0835 37.714 21.1494 38.3333 21.2752'
      stroke='url(#paint3_radial_5314_712)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
    />
    <path
      fill='none'
      d='M8.62492 36.4168C11.2713 36.4168 13.4166 34.2715 13.4166 31.6252C13.4166 28.9788 11.2713 26.8335 8.62492 26.8335C5.97855 26.8335 3.83325 28.9788 3.83325 31.6252C3.83325 34.2715 5.97855 36.4168 8.62492 36.4168Z'
      stroke='url(#paint4_linear_5314_712)'
      strokeWidth='2.875'
    />
    <path
      fill='none'
      d='M8.62492 36.4168C11.2713 36.4168 13.4166 34.2715 13.4166 31.6252C13.4166 28.9788 11.2713 26.8335 8.62492 26.8335C5.97855 26.8335 3.83325 28.9788 3.83325 31.6252C3.83325 34.2715 5.97855 36.4168 8.62492 36.4168Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
    />
    <path
      fill='none'
      d='M8.62492 36.4168C11.2713 36.4168 13.4166 34.2715 13.4166 31.6252C13.4166 28.9788 11.2713 26.8335 8.62492 26.8335C5.97855 26.8335 3.83325 28.9788 3.83325 31.6252C3.83325 34.2715 5.97855 36.4168 8.62492 36.4168Z'
      stroke='url(#paint5_radial_5314_712)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
    />
    <path
      fill='none'
      d='M12.3247 18.4571H15.6336C16.5067 18.4571 17.3537 18.159 18.0343 17.6122L21.5382 14.7974C21.8784 14.524 22.302 14.375 22.7386 14.375H28.7501L23.545 23.9179C23.209 24.5335 22.5637 24.9167 21.8623 24.9167H18.2084M12.3247 18.4571H7.66675M12.3247 18.4571L18.2084 24.9167M18.2084 24.9167L13.4167 30.6667'
      stroke='url(#paint6_linear_5314_712)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M12.3247 18.4571H15.6336C16.5067 18.4571 17.3537 18.159 18.0343 17.6122L21.5382 14.7974C21.8784 14.524 22.302 14.375 22.7386 14.375H28.7501L23.545 23.9179C23.209 24.5335 22.5637 24.9167 21.8623 24.9167H18.2084M12.3247 18.4571H7.66675M12.3247 18.4571L18.2084 24.9167M18.2084 24.9167L13.4167 30.6667'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M12.3247 18.4571H15.6336C16.5067 18.4571 17.3537 18.159 18.0343 17.6122L21.5382 14.7974C21.8784 14.524 22.302 14.375 22.7386 14.375H28.7501L23.545 23.9179C23.209 24.5335 22.5637 24.9167 21.8623 24.9167H18.2084M12.3247 18.4571H7.66675M12.3247 18.4571L18.2084 24.9167M18.2084 24.9167L13.4167 30.6667'
      stroke='url(#paint7_radial_5314_712)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M32.5833 21.0832L26.8185 10.9948C26.0422 9.63653 25.6543 8.95742 25.0766 8.49849C24.7849 8.26667 24.4608 8.07864 24.1148 7.94034C23.4298 7.6665 22.6476 7.6665 21.0833 7.6665'
      stroke='url(#paint8_linear_5314_712)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M32.5833 21.0832L26.8185 10.9948C26.0422 9.63653 25.6543 8.95742 25.0766 8.49849C24.7849 8.26667 24.4608 8.07864 24.1148 7.94034C23.4298 7.6665 22.6476 7.6665 21.0833 7.6665'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M32.5833 21.0832L26.8185 10.9948C26.0422 9.63653 25.6543 8.95742 25.0766 8.49849C24.7849 8.26667 24.4608 8.07864 24.1148 7.94034C23.4298 7.6665 22.6476 7.6665 21.0833 7.6665'
      stroke='url(#paint9_radial_5314_712)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5314_712'
        x1='32.5833'
        y1='26.8335'
        x2='43.5385'
        y2='34.4413'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5314_712'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(37.3749 36.4168) scale(4.79167 4.88019)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_5314_712'
        x1='26.8333'
        y1='21.0835'
        x2='41.2215'
        y2='29.6479'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_5314_712'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(32.5833 34.5002) scale(5.75 6.83226)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_5314_712'
        x1='3.83325'
        y1='26.8335'
        x2='14.7885'
        y2='34.4413'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_5314_712'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(8.62492 36.4168) scale(4.79167 4.88019)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint6_linear_5314_712'
        x1='7.66675'
        y1='14.375'
        x2='27.4297'
        y2='32.1359'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint7_radial_5314_712'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(18.2084 30.6667) scale(10.5417 8.29632)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint8_linear_5314_712'
        x1='21.0833'
        y1='7.6665'
        x2='35.4715'
        y2='16.2309'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint9_radial_5314_712'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(26.8333 21.0832) scale(5.75 6.83226)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'SpeedwayIcon'
)

export default SpeedwayIcon
